module.exports = __webpack_public_path__ + "static/media/ImageFive.4e6b379c.jpg";